import { NgModule } from '@angular/core';
import { FallbackTileComponent } from './fallback-tile.component';

@NgModule({
   declarations: [FallbackTileComponent],
   imports: [],
   exports: [FallbackTileComponent],
})
export class FallbackTileModule {}
